import styled from 'styled-components';
import theme from 'styled-theming';

import Card from '../../../../UI/Card';

export const cardBackgroundColor = theme('name', {
  light: '#ffffff',
  dark: '#2d2d2d',
});

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 10px 15px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;

  button {
    min-width: 90px;
    border-radius: 6px;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
    }

    &:active {
      transform: translateY(1px);
    }
  }

  button:last-child {
    margin-left: 12px;
  }

  &.upload-aligne {
    .button-wrapper {
      display: flex;
    }
  }

  &.upload-aligne__confirm {
    justify-content: space-between;
    .message {
      display: flex;
      align-items: center;
      margin-right: 10px;
      font-weight: 500;
      color: rgba(217, 54, 56, 1);
    }
  }

  &.report-modal-footer {
    justify-content: space-between;
  }
`;

export const CustomCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 24px;
  background-color: ${cardBackgroundColor};
  transition: all 0.3s ease;
  .heading-container {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 16px;
    width: 100%;

    h2 {
      font-size: 24px;
      font-weight: 600;
      margin: 0;
    }

    .close-mapping {
      &:hover {
        transform: scale(1.1);
        opacity: 0.8;
      }
    }
  }

  .search-filter-container {
    display: flex;
    align-items: center;
    gap: 16px;

    .search-input {
      flex: 1;
      max-width: 300px;

      input {
        border: 1px solid #e0e0e0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      }
    }

    .checkbox-container {
      display: flex;
      align-items: center;
      margin-left: 16px;
    }
  }

  .action-buttons-container {
    display: flex;
    gap: 12px;
    justify-content: flex-end;

    button {
      border-radius: 8px;
      transition: all 0.2s ease;
      padding: 6px 16px;
    }
  }
`;

export const StatusIcon = styled.img`
  width: 20px;
  height: 20px;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.2);
  }
`;

export const AuditTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #444;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
`;

export const ActionsCell = styled.div`
  .grid-actions {
    display: flex;
    gap: 10px;
  }

  button {
    opacity: 0.7;
    transition: all 0.2s ease;

    &:hover {
      opacity: 1;
      transform: scale(1.1);
    }
  }
`;
